<script setup>

import MaskIcon from "@/Components/MaskIcon.vue";
import {ref, watch} from "vue";

let bodyCollapse = ref(null),
    arrow = ref(null)

const props = defineProps({
    title: String,
    modelValue: {
        type: Boolean,
        default: false,
    }
})

const emits = defineEmits('update:modelValue')

watch(() => props.modelValue, (val) => {
    if (val) {
        bodyCollapse.value.classList.remove('hidden')
        arrow.value.$el.style.transform = 'rotate(180deg)'
    } else {
        arrow.value.$el.style.transform = 'rotate(0deg)'
        bodyCollapse.value.classList.add('hidden')
    }
})

</script>

<template>
    <div class="">

        <div class="flex justify-between items-center cursor-pointer pr-3 py-3 lg:px-3" @click="emits('update:modelValue', !props.modelValue)">
            <slot name="header">
                <div class="leading-120">
                    <div class="text-xl dark:text-slate-200 font-bold">
                        {{ title }}
                    </div>
                </div>
            </slot>
            <MaskIcon src="/assets/icons/arrow.svg" ref="arrow" class="w-6 h-6 bg-[#21272A] dark:bg-white"/>
        </div>
        <div ref="bodyCollapse" style="transition: height .5s" class="hidden transition overflow-hidden">
            <slot>

            </slot>
        </div>
    </div>
</template>

<style scoped>

</style>
